import type { SkillTaxonomyDto } from '@eva/types/dto';

export const filterSkillTaxonomiesByUserGroupId = (skillTaxonomies: SkillTaxonomyDto[], userGroupIds: number[]) =>
  skillTaxonomies.filter((skillTaxonomy) =>
    skillTaxonomy.userGroups.find((userGroup) => userGroupIds.includes(userGroup.userGroupId)),
  );
